import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from './components/App/AppWrapper';

ReactDOM.render(<AppWrapper />, document.getElementById('root'));
